/**
 * NotificationBadge - Sprint 19b
 *
 * Badge showing unread notifications count.
 * Displays 99+ if count exceeds 99.
 * @see US-19b.06
 */

interface NotificationBadgeProps {
  count: number;
  className?: string;
}

export function NotificationBadge({ count, className = '' }: NotificationBadgeProps) {
  if (count <= 0) {
    return null;
  }

  const displayCount = count > 99 ? '99+' : count.toString();
  const minWidth = count > 9 ? 'min-w-[1.5rem]' : 'min-w-[1.125rem]';

  return (
    <span
      className={`
        absolute -top-1 -right-1
        flex items-center justify-center
        ${minWidth} h-[1.125rem]
        px-1 text-[10px] font-medium
        bg-red-500 text-white
        rounded-full
        ${className}
      `}
    >
      {displayCount}
    </span>
  );
}
